<template>
    <div v-if="!loading" class="pb-2">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">تیکت‌ها</h3>
            <b-button v-b-modal.create-ticket variant="primary" class="mb-2">
                ثبت تیکت جدید
            </b-button>
        </div>
        <div v-if="tickets.length">
            <b-card class="p-0" no-body>
                <b-overlay :show="loadingPage" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table responsive :items="tickets" :fields="fields" class="mb-0">
                        <template #cell(status)="data">
                            <b-badge :variant="ticketVariant(data.item.status)" pill>
                                {{ ticketStatus(data.item.status) }}
                            </b-badge>
                        </template>
                        <template #cell(id)="data">
                            <router-link :to="`/tickets/details?id=${data.item.id}`"
                                :class="{ 'text-muted': data.item.status == 2 || data.item.status == 3 }">
                                {{ data.item.id }}
                            </router-link>
                        </template>
                        <template #cell(subject)="data">
                            <div :class="{ 'text-muted': data.item.status == 2 || data.item.status == 3 }">
                                {{ data.item.subject }}
                            </div>
                        </template>
                        <template #cell(details)="data">
                            <router-link :to="`/tickets/details?id=${data.item.id}`">
                                <feather-icon icon="ArrowLeftIcon" size="19"
                                    :class="{ 'text-muted': data.item.status == 2 || data.item.status == 3 }" />
                            </router-link>
                        </template>
                        <template #cell(lastModifiedAt)="data">
                            <div :class="{ 'text-muted': data.item.status == 2 || data.item.status == 3 }">
                                <span>
                                    {{ new Date(data.item.lastModifiedAt).toLocaleTimeString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new Date(data.item.lastModifiedAt).toLocaleDateString('fa-IR') }}
                                </span>
                            </div>
                        </template>
                    </b-table>
                </b-overlay>
            </b-card>
            <b-pagination align="center" @input="getTickets" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>
        <h5 v-else class="d-flex align-items-center justify-content-center" style="min-height: 63vh;">
            موردی وجود ندارد
        </h5>

        <!------------------------------- modal create ticket ------------------------------->
        <b-modal id="create-ticket" title="تیکت جدید" centered :hide-footer="true" title-class="font-weight-bolder"
            size="md">
            <b-card-text class="p-1">
                <validation-observer #default="{ invalid }">
                    <b-form @submit.prevent>
                        <div>
                            <div>
                                <validation-provider #default="{ errors }" name="عنوان" rules="required">
                                    <b-form-input placeholder="عنوان" v-model="form.subject"
                                        :state="errors.length > 0 ? false : null"></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </div>
                            <div class="mt-2">
                                <validation-provider #default="{ errors }" name="توضیحات" rules="required">
                                    <b-form-textarea v-model="form.text" placeholder="توضیحات" dir="rtl"
                                        class="text-primary-middle" :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center my-3">
                            <div style="width: 250px;height: 250px;">
                                <div @click="selectFile" :class="{ 'upload-file': !imageBlob }"
                                    class="pointer d-flex justify-content-center align-items-center">
                                    <input @change.prevent="createFile" ref="fileInput"
                                        accept="image/png, image/jpeg, image/webp" type="file" hidden />
                                    <div v-if="!imageBlob">
                                        <feather-icon size="95" icon="UploadCloudIcon" color="#7367f0f0" />
                                        <h5 class="text-primary mb-0 mt-1">پیوست تصویر</h5>
                                    </div>
                                    <div v-if="imageBlob" class="ticket-img">
                                        <b-img :src="imageBlob" class="object-fit-cover w-100 h-100"
                                            style="border-radius: 18px;" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center pt-1">
                            <b-button @click="$bvModal.hide('create-ticket')" class="w-50 mr-1" variant="secondary">
                                انصراف
                            </b-button>
                            <b-button @click="createTicket"
                                class="d-flex align-items-center justify-content-center w-50" variant="primary"
                                :disabled="invalid || loadingButton">
                                <span>ارسال تیکت</span>
                                <b-spinner v-if="loadingButton" class="ml-50" variant="white" small></b-spinner>
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer>
            </b-card-text>
        </b-modal>
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BForm, BFormInput, BFormTextarea, BImg, BBadge, BSpinner, BOverlay } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import { storeService } from '@core/services';
import Compressor from 'compressorjs';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BForm,
        BFormInput,
        BFormTextarea,
        BImg,
        BBadge,
        BSpinner,
        BOverlay
    },
    data() {
        return {
            required,
            storeId: null,
            tickets: [],
            loading: true,
            loadingPage: false,
            loadingButton: false,
            fields: [
                {
                    key: 'id',
                    label: 'شناسه',
                },
                {
                    key: 'subject',
                    label: 'عنوان',
                },
                {
                    key: 'lastModifiedAt',
                    label: 'تاریخ آخرین به‌روز‌رسانی',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null
            },
            imageBlob: null,
            form: {
                subject: null,
                text: null,
                attachmentFile: null,
            },
        }
    },
    computed: {
        ticketStatus() {
            return (status) => {
                if (status == 0) {
                    return 'درحال بررسی'
                }
                if (status == 1) {
                    return 'پاسخ داده شده'
                }
                if (status == 2) {
                    return 'بسته شده'
                }
                if (status == 3) {
                    return 'بسته شده'
                }
            }
        },
        ticketVariant() {
            return (status) => {
                if (status == 0) {
                    return 'light-primary'
                }
                if (status == 1) {
                    return 'light-success'
                }
                if (status == 2) {
                    return 'light-secondary'
                }
                if (status == 3) {
                    return 'light-secondary'
                }
            }
        },
    },
    methods: {
        createFile(event) {
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            this.form.attachmentFile = result
                            if (this.form.attachmentFile) {
                                this.imageBlob = URL.createObjectURL(this.form.attachmentFile);
                            }
                        },
                    });

                }
                else {
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                }
            }
            else {
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
            }
        },
        selectFile() {
            this.$refs['fileInput'].click();
        },
        getTickets() {
            this.loadingPage = true
            storeService.getTickets(this.storeId, this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.tickets = data.items
                this.loadingPage = false
                this.loading = false;
            })
                .catch(() => { });
        },
        createTicket() {
            this.loadingButton = true;
            let formData = new FormData();
            this.form.attachmentFile ? formData.append("attachmentFile", this.form.attachmentFile, this.form.attachmentFile.name) : null
            formData.append("text", this.form.text)
            formData.append("subject", this.form.subject)
            storeService.createTicket(this.storeId, formData).then(({ data }) => {
                this.$router.push(`/tickets/details?id=${data.id}`)
            })
                .finally(() => {
                    this.loadingButton = false;
                });
        }
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getTickets()
    },
};
</script>

<style lang="scss">
.upload-file {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='18' ry='18' stroke='%235E50EE95' stroke-width='4' stroke-dasharray='8%2c 16' stroke-dashoffset='15' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 18px;
    Width: 100%;
    height: 250px;
    margin: 0 0 0 0;
}

.ticket-img {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 16px;
    width: 250px;
    height: 250px;
}
</style>